import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  
  {
    path: '/end',
    name: 'end',
    component: () => import('../views/ResultView.vue')
  },

  {
    path: '/exam/:shikenId/:id',
    name: 'Exam',
    component: () => import('../views/Exam.vue')
  },

  {
    path: '/start/:shikenId',
    name: 'start',
    component: () => import('../views/Start.vue')
  },
  {
    path: '/',
    name: 'home',
    component: HomeView
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // scrollBehavior (to, from, savedPosition) {
  //   if (savedPosition) {
  //      return savedPosition
  //   } else {
  //      return { x: 0, y: 0 }
  //   }
  // }
})

export default router
